<template>
  <output-dialog
    :aspectRatio="1000/1132"
    :background="require('@/assets/img/SjlModel.jpg')"
    :fields="fields"
    :pages="pages"
    filename="SjlModel.pdf"
    orientation="portrait"
    ref="printDlg"
    title="事業本部 登録用紙"
  />
</template>
<script>
export default {
  data() {
    return {
      fields: [
        {},
        {
          name: 'name1',
          style: {
            left: '320.73px',
            top: '440.21px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name2',
          style: {
            left: '360.73px',
            top: '440.21px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name3',
          style: {
            left: '400.73px',
            top: '440.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name4',
          style: {
            left: '440.73px',
            top: '440.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name5',
          style: {
            left: '480.73px',
            top: '440.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name6',
          style: {
            left: '520.73px',
            top: '440.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name7',
          style: {
            left: '560.73px',
            top: '440.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name8',
          style: {
            left: '600.73px',
            top: '440.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name9',
          style: {
            left: '640.73px',
            top: '440.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name',
          style: {
            left: '336.73px',
            top: '465.08px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'showName',
          style: {
            left: '336.73px',
            top: '490.08px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'englishName',
          style: {
            left: '336.73px',
            top: '510.08px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'companyName',
          style: {
            left: '336.73px',
            top: '535.08px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'companyType',
          style: {
            left: '336.73px',
            top: '560.08px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'bu',
          style: {
            left: '336.73px',
            top: '580.08px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'department',
          style: {
            left: '336.73px',
            top: '605.08px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'position',
          style: {
            left: '336.73px',
            top: '630.08px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'email',
          style: {
            left: '336.73px',
            top: '700.08px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'outsideLineNumber',
          style: {
            left: '336.73px',
            top: '655.08px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'insideLineNumber',
          style: {
            left: '336.73px',
            top: '675.08px',
            fontSize: '12px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        }
      ],
      pages: []
    }
  },
  methods: {
    popup(pages) {
      this.$refs.printDlg.show = true
      this.pages = pages
    }
  }
}
</script>